module.exports = __webpack_public_path__ + "img/switzerland-digestive-diseases-female.e6db5e8c.png";